module.exports = __webpack_public_path__ + "static/media/DrMundo.932f656f.png";